import seoApiFactory from '../../modules/seo/seoApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getSeoInfoActionCreators,
  getGenericSeoInfoActionCreators,
  getDeeplinkActionCreators,
} from '../actions/seoActions';

function seoSagasFactory({storefrontApiClient}) {
  const seoApi = seoApiFactory(storefrontApiClient);

  const getSeoInfoSaga = generateDefaultAsyncSaga(
    seoApi.getSeoInfo,
    getSeoInfoActionCreators,
    payload => [
      payload.params,
    ]
  );

  const getGenericSeoInfoSaga = generateDefaultAsyncSaga(
    seoApi.getGenericSeoInfo,
    getGenericSeoInfoActionCreators,
    payload => [
      payload.body,
    ]
  );

  const getDeepLinkSaga = generateDefaultAsyncSaga(
    seoApi.getDeepLink,
    getDeeplinkActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetSeoInfo = generateDefaultAsyncWatcher(
    'GET_SEO_INFO',
    getSeoInfoSaga
  );

  const watchGetGenericSeoInfo = generateDefaultAsyncWatcher(
    'GET_GENERIC_SEO_INFO',
    getGenericSeoInfoSaga
  );

  const watchGetDeepLink = generateDefaultAsyncWatcher(
    'GET_DEEP_LINK',
    getDeepLinkSaga
  );

  const seoSagas = [
    watchGetSeoInfo(),
    watchGetGenericSeoInfo(),
    watchGetDeepLink(),
  ];

  return seoSagas;
}

export default seoSagasFactory;
